import * as React from 'react';
import { IEmail } from '../../../Types';
import { Table } from 'react-bootstrap';
import { Translate } from '../../../../../../../shared/LanguageService';
import EmailListRow from './EmailListRow';
import BasicOrderInfoApi from "../../../BasicOrderInfoApi";
import { useQuery } from "react-query";
import { handleError } from "../../../../../../../shared/ErrorCatching";

type EmailListProps = {
    items: IEmail[];
    viewDetails: (email: IEmail) => void;
}

type ExternalProps = {
    viewDetails: (email: IEmail) => void;
    orderId: number;
}

function EmailList({ items, viewDetails }: EmailListProps) {
    return (
        <Table responsive>
            <thead>
                <tr className="table_header">
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/subject'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/created'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/sent'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/failed'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/desired-send-time'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-emails/table-headers/from'
                        )}
                    </th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {items
                    ? items
                          .sort(
                              (a: IEmail, b: IEmail) =>
                                  new Date(a.createdTime).getTime() -
                                  new Date(b.createdTime).getTime()
                          )
                          .map((e: IEmail) => {
                              return (
                                  <EmailListRow item={e} key={e.id} onView={viewDetails} />
                              );
                          })
                    : null}
            </tbody>
        </Table>
    );
}

export const EmailListQueryKey = 'EmailListQueryKey';

export default function EmailListDataLayer({ viewDetails, orderId }: ExternalProps) {
    
    let { data, isError, error } = useQuery(
        [EmailListQueryKey, orderId],
        () => BasicOrderInfoApi.getEmails(orderId),
        { suspense: true, useErrorBoundary: false, retry: false }
    )
    
    if (isError) {
        handleError(error);
        return <EmailList items={[]} viewDetails={viewDetails} />
    }
    
    return <EmailList items={data} viewDetails={viewDetails} />;
}
